import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getEnquiryManagementView = createAsyncThunk(
  "enqMngt/getEnquiryManagementView",
  async (statusId) => {
    const formattedStatusId = Array.isArray(statusId) ? statusId.join(",") : statusId;
    const response = await axios.get(
      `/api/admin/enquiryMgmtView?statusId=${formattedStatusId}`
    );
    return response.enquiryMgmtView;
  }
);

export const getBusByPan = createAsyncThunk(
  "enqMngt/getBusByPan",
  async (pan) => {
    const response = await axios.get(
      `/api/admin/getBusByPan?pan=${pan}`
    );
    return response;
  }
);

export const getStatusList = createAsyncThunk(
  "enqMngt/getStatusList",
  async (statusType) => {
    const response = await axios.get(
      `/api/admin/getStatusList?${statusType}=true`
    );
    return response;
  }
);

export const getDropdownData = createAsyncThunk(
  "enqMngt/getDropdownData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get("/api/admin/getIndBusAtList");
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const addNewEnquiry = createAsyncThunk(
  "enqMngt/addNewEnquiry",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/addNewEnquiry", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const assignEnquiry = createAsyncThunk(
  "enqMngt/assignEnquiry",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/assignEnquiry`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const rejectEnquiry = createAsyncThunk(
  "enqMngt/rejectEnquiry",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/rejectEnquiry`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const jvRejectEnquiry = createAsyncThunk(
  "enqMngt/jvRejectEnquiry",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/rejectEnquiry`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);



export const activateEnquiry = createAsyncThunk(
  "enqMngt/activateEnquiry",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/activateEnquiry`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const deactivateOrg = createAsyncThunk(
  "enqMngt/deactivateOrg",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/deactivateOrg`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const reopenEnquiry = createAsyncThunk(
  "enqMngt/reopenEnquiry",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/reopenEnquiry`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const deliquentBus = createAsyncThunk(
  "enqMngt/deliquentBus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/deliquentBus`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const blacklistBus = createAsyncThunk(
  "enqMngt/blacklistBus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/blacklistBus`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const reactivateOrg = createAsyncThunk(
  "enqMngt/reactivateOrg",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/reactivateOrg`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const activateUser = createAsyncThunk(
  "enqMngt/activateUser",
  async (orgId, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/activateUser?orgId=${orgId}`);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const verifyPan = createAsyncThunk(
  "enqMngt/verifyPan",
  async ({ orgId, pan, busName, dealCategoryId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/verifyBusPan`, {
        orgId: orgId,
        busName: busName,
        pan: pan,
        ...(dealCategoryId && { dealCategoryId }),
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const verifyDirectorPan = createAsyncThunk(
  "enqMngt/verifyDirectorPan",
  async ({ orgId, directorPan, directorName }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/verifyDirectorPan`, {
        orgId: orgId,
        directorName: directorName,
        pan: directorPan,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const verifyBusGstin = createAsyncThunk(
  "enqMngt/verifyBusGstin",
  async ({ orgId, gstin, dealCategoryId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/verifyBusGstin`, {
        orgId: orgId,
        gstin: gstin,
        ...(dealCategoryId && { dealCategoryId }),
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const verifyIfsc = createAsyncThunk(
  "enqMngt/verifyIfsc",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/verifyIfsc`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const verifyBank = createAsyncThunk(
  "enqMngt/verifyBank",
  async ({ orgId, ifsc, accountNumber, accountName, dealCategoryId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/verifyBank`, {
        ifscId: ifsc,
        accNum: accountNumber,
        orgId: orgId,
        accHolderName: accountName,
        ...(dealCategoryId && { dealCategoryId }),
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getPendingKyc = createAsyncThunk(
  "enqMngt/getPendingKyc",
  async (payload) => {
    const orgId = typeof payload === "object" ? payload.orgId : payload;
    const dealCategoryId =
      typeof payload === "object" ? payload.dealCategoryId : undefined;
    const dealCategoryQuery = dealCategoryId
      ? `&dealCategoryId=${dealCategoryId}`
      : "";
    const response = await axios.get(
      `/api/admin/getPendingKyc?orgId=${orgId}${dealCategoryQuery}`
    );
    return response.response;
  }
);

export const kycHistory = createAsyncThunk(
  "enqMngt/kycHistory",
  async (orgId) => {
    const response = await axios.get(`/api/admin/kycHistory?orgId=${orgId}`);
    return response.response;
  }
);

export const getConsentDigilocker = createAsyncThunk(
  "enqMngt/getConsentDigilocker",
  async (payload, { rejectWithValue }) => {
    const orgId = typeof payload === "object" ? payload.orgId : payload;
    const dealCategoryId =
      typeof payload === "object" ? payload.dealCategoryId : undefined;
    const dealCategoryQuery = dealCategoryId
      ? `&dealCategoryId=${dealCategoryId}`
      : "";
    try {
      const response = await axios.get(
        `/api/admin/getConsentDigilocker?orgId=${orgId}${dealCategoryQuery}`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getAadhaarAndPan = createAsyncThunk(
  "enqMngt/getAadhaarAndPan",
  async (payload, { rejectWithValue }) => {
    const orgId = typeof payload === "object" ? payload.orgId : payload;
    const dealCategoryId =
      typeof payload === "object" ? payload.dealCategoryId : undefined;
    const dealCategoryQuery = dealCategoryId
      ? `&dealCategoryId=${dealCategoryId}`
      : "";
    try {
      const response = await axios.get(
        `/api/admin/getAadhaarAndPan?orgId=${orgId}${dealCategoryQuery}`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const verifyAadhaarCaptcha = createAsyncThunk(
  "enqMngt/verifyAadhaarCaptcha",
  async (
    { orgId, sessionId, directorAadhar, captcheCode },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(`/api/admin/verifyAadhaarCaptcha`, {
        orgId: orgId,
        sessionId: sessionId,
        aadhaar: directorAadhar,
        captcha: captcheCode,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const verifyAadhaarOtp = createAsyncThunk(
  "enqMngt/verifyAadhaarOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/verifyAadhaarOtp", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const pendingKycSubmit = createAsyncThunk(
  "enqMngt/pendingKycSubmit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/pendingKycSubmit", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const financialDocUpload = createAsyncThunk(
  "enqMngt/financialDocUpload",
  async ({ orgId, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/financialDocUpload?orgId=${orgId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const verifyDoc = createAsyncThunk(
  "enqMngt/verifyDoc",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/verifyDoc", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const rejectDoc = createAsyncThunk(
  "enqMngt/rejectDoc ",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/rejectDoc ", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const reviewKycSubmit = createAsyncThunk(
  "enqMngt/reviewKycSubmit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/reviewKycSubmit", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const sendKycRemainder = createAsyncThunk(
  "enqMngt/sendKycRemainder",
  async (orgId) => {
    const response = await axios.get(
      `/api/admin/sendKycRemainder?orgId=${orgId}`
    );
    return response.response;
  }
);

////////kyc verification/////////////////////////////////////////////////////////////

export const busGetIndBusAtList = createAsyncThunk(
  "enqMngt/busGetIndBusAtList",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/busGetIndBusAtList", {
        token,
      });
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busVerifyBusPan = createAsyncThunk(
  "enqMngt/busVerifyBusPan",
  async ({ orgId, pan, busName, token, dealCategoryId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/busVerifyBusPan`, {
        orgId: orgId,
        busName: busName,
        pan: pan,
        token,
        ...(dealCategoryId && { dealCategoryId }),
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busVerifyDirectorPan = createAsyncThunk(
  "enqMngt/busVerifyDirectorPan",
  async ({ orgId, directorPan, directorName, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/busVerifyDirectorPan`, {
        orgId: orgId,
        directorName: directorName,
        pan: directorPan,
        token,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busVerifyBusGstin = createAsyncThunk(
  "enqMngt/busVerifyBusGstin",
  async ({ orgId, gstin, token, dealCategoryId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/busVerifyBusGstin`, {
        orgId: orgId,
        gstin: gstin,
        token,
        ...(dealCategoryId && { dealCategoryId }),
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busVerifyIfsc = createAsyncThunk(
  "enqMngt/busVerifyIfsc",
  async ({ orgId, ifscCode, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/admin/busVerifyIfsc`, {
        ifscCode,
        orgId,
        token,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busVerifyBank = createAsyncThunk(
  "enqMngt/busVerifyBank",
  async (
    { orgId, ifsc, accountNumber, accountName, token },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(`/api/admin/busVerifyBank`, {
        ifscId: ifsc,
        accNum: accountNumber,
        orgId: orgId,
        accHolderName: accountName,
        token,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busGetPendingKyc = createAsyncThunk(
  "enqMngt/busGetPendingKyc",
  async ({ orgId, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/busGetPendingKyc?orgId=${orgId}`,
        { token }
      );
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busKycHistory = createAsyncThunk(
  "enqMngt/busKycHistory",
  async ({ orgId, token }) => {
    const response = await axios.post(
      `/api/admin/busKycHistory?orgId=${orgId}`,
      { token }
    );
    return response.response;
  }
);

export const busGetAadhaarCaptcha = createAsyncThunk(
  "enqMngt/busGetAadhaarCaptcha",
  async ({ orgId, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `/api/admin/busGetAadhaarCaptcha?orgId=${orgId}`,
        { token }
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busVerifyAadhaarCaptcha = createAsyncThunk(
  "enqMngt/busVerifyAadhaarCaptcha",
  async (
    { orgId, sessionId, directorAadhar, captcheCode, token },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(`/api/admin/busVerifyAadhaarCaptcha`, {
        orgId: orgId,
        sessionId: sessionId,
        aadhaar: directorAadhar,
        captcha: captcheCode,
        token,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busVerifyAadhaarOtp = createAsyncThunk(
  "enqMngt/busVerifyAadhaarOtp",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/admin/busVerifyAadhaarOtp",
        payload
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busKycSubmit = createAsyncThunk(
  "enqMngt/busKycSubmit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/busKycSubmit", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busGetConsentDigilocker = createAsyncThunk(
  "enqMngt/busGetConsentDigilocker",
  async ({ orgId, token, dealCategoryId }, { rejectWithValue }) => {
    const dealCategoryQuery = dealCategoryId
      ? `&dealCategoryId=${dealCategoryId}`
      : "";
    try {
      const response = await axios.post(
        `/api/admin/busGetConsentDigilocker?orgId=${orgId}${dealCategoryQuery}`,
        { token }
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const busGetAadhaarAndPan = createAsyncThunk(
  "enqMngt/busGetAadhaarAndPan",
  async ({ orgId, token, dealCategoryId }, { rejectWithValue }) => {
    const dealCategoryQuery = dealCategoryId
      ? `&dealCategoryId=${dealCategoryId}`
      : "";
    try {
      const response = await axios.post(
        `/api/admin/busGetAadhaarAndPan?orgId=${orgId}${dealCategoryQuery}`,
        { token }
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getRmCities = createAsyncThunk(
  "enqMngt/getRmCities",
  async ({ forBusiness }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/admin/getRmCities?forBusiness=${forBusiness}`
      ); //using only one time
      return response.response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const resendKycLink = createAsyncThunk(
  "enquiryManagement/resendKycLink",
  async (payload, { rejectWithValue }) => {
    try {
      const orgId = typeof payload === "object" ? payload.orgId : payload;
      const dealCategoryId =
        typeof payload === "object" ? payload.dealCategoryId : undefined;
      const dealCategoryQuery = dealCategoryId
        ? `&dealCategoryId=${dealCategoryId}`
        : "";
      const response = await axios.get(
        `/api/admin/resendKycLink?orgId=${orgId}${dealCategoryQuery}`
      );
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const sendDirectorKycLink = createAsyncThunk(
  "enquiryManagement/sendDirectorKycLink",
  async ({ orgId, dealCategoryId }, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/sendDirectorKycLink", {
        orgId,
        dealCategoryId,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const EnqMngtSlice = createSlice({
  name: "enqMngt",
  initialState: {
    loading: false,
    error: "",
    AadharPanError: "",
    newEnquiryLoading: false,
    commentSubmitLoading: false,
    commentSubmitError: "",
    rejectSubmitError: "",
    rejectSubmitLoading: false,
    enquiryList: [],
    busList: [],
    statusList: [],
    panData: {},
    panError: "",
    gstinError:"",
    panLoading: false,
    directorPanLoading: false,
    gstinLoading: false,
    ifscData: {},
    ifscLoading: false,
    bankLoading: false,
    dropdownData: {},
    pendingKycData: {},
    kycHistoryData: {},
    captche: {},
    digilockerLoading: false,
    verifyCaptchaloading: false,
    AadharOtpData: {},
    aadharValidateLoading: false,
    pendingKycSubmitLoading: false,
    verifyDocLoading: false,
    rejectDocLoading: false,
    rejectDocError: "",
    reviewKycSubmitLoading: false,
    kycRemainder: "",
    aadhaarPanData: {},
    AadharPanLoading: false,
    allCities: [],
    isLinkExpired: false,
    // otpData: {},
    // otpError: "",
    // validateOtpLoading: false,
  },

  extraReducers: (builder) => {
    builder.addCase(getStatusList.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getStatusList.fulfilled, (state, action) => {
      state.loading = false;
      state.statusList = action.payload.response;
    });
    builder.addCase(getStatusList.rejected, (state, action) => {
      state.loading = false;
      state.statusList = [];
      state.error = action.payload;
    });

    builder.addCase(getDropdownData.fulfilled, (state, action) => {
      state.dropdownData = action.payload;
    });

    builder.addCase(addNewEnquiry.pending, (state) => {
      state.newEnquiryLoading = true;
      state.error = "";
    });
    builder.addCase(addNewEnquiry.fulfilled, (state, action) => {
      state.newEnquiryLoading = false;
      state.error = "";
    });
    builder.addCase(addNewEnquiry.rejected, (state, action) => {
      state.newEnquiryLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getEnquiryManagementView.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getEnquiryManagementView.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
      state.enquiryList = action.payload;
    });
    builder.addCase(getEnquiryManagementView.rejected, (state, action) => {
      state.loading = false;
      state.enquiryList = [];
      state.error = action.payload;
    });

    builder.addCase(getBusByPan.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getBusByPan.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
      state.busList = action.payload;
    });
    builder.addCase(getBusByPan.rejected, (state, action) => {
      state.loading = false;
      state.busList = [];
      state.error = action.payload;
    });

    builder.addCase(assignEnquiry.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(assignEnquiry.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(assignEnquiry.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(activateEnquiry.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(activateEnquiry.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(activateEnquiry.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(deactivateOrg.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(deactivateOrg.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(deactivateOrg.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(reactivateOrg.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(reactivateOrg.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(reactivateOrg.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(rejectEnquiry.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(rejectEnquiry.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(rejectEnquiry.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(jvRejectEnquiry.pending, (state) => {
      state.rejectSubmitLoading = true;
      state.rejectSubmitError = "";
    });
    builder.addCase(jvRejectEnquiry.fulfilled, (state, action) => {
      state.rejectSubmitLoading = false;
      state.rejectSubmitError = "";
    });
    builder.addCase(jvRejectEnquiry.rejected, (state, action) => {
      state.rejectSubmitLoading = false;
      state.rejectSubmitError = action.payload;
    });

    builder.addCase(reopenEnquiry.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(reopenEnquiry.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(reopenEnquiry.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(activateUser.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(activateUser.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(activateUser.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(verifyPan.pending, (state) => {
      state.panLoading = true;
      state.panError = "";
    });
    builder.addCase(verifyPan.fulfilled, (state, action) => {
      state.panLoading = false;
      state.panData = action.payload;
    });
    builder.addCase(verifyPan.rejected, (state, action) => {
      state.panLoading = false;
      state.panData = {};
      state.panError = action.payload;
    });

    builder.addCase(verifyDirectorPan.pending, (state) => {
      state.directorPanLoading = true;
      state.error = "";
    });
    builder.addCase(verifyDirectorPan.fulfilled, (state, action) => {
      state.directorPanLoading = false;
      state.error = "";
    });
    builder.addCase(verifyDirectorPan.rejected, (state, action) => {
      state.directorPanLoading = false;
      state.error = action.payload;
    });

    builder.addCase(verifyBusGstin.pending, (state) => {
      state.gstinLoading = true;
      state.gstinError = "";
    });
    builder.addCase(verifyBusGstin.fulfilled, (state, action) => {
      state.gstinLoading = false;
      state.gstinError = "";
    });
    builder.addCase(verifyBusGstin.rejected, (state, action) => {
      state.gstinLoading = false;
      state.gstinError = action.payload;
    });

    builder.addCase(verifyIfsc.pending, (state) => {
      state.ifscLoading = true;
      state.error = "";
    });
    builder.addCase(verifyIfsc.fulfilled, (state, action) => {
      state.ifscLoading = false;
      state.ifscData = action.payload.response;
    });
    builder.addCase(verifyIfsc.rejected, (state, action) => {
      state.ifscLoading = false;
      state.ifscData = {};
      state.error = action.payload;
    });

    builder.addCase(verifyBank.pending, (state) => {
      state.bankLoading = true;
      state.error = "";
    });
    builder.addCase(verifyBank.fulfilled, (state, action) => {
      state.bankLoading = false;
      state.error = "";
    });
    builder.addCase(verifyBank.rejected, (state, action) => {
      state.bankLoading = false;
      state.error = action.payload;
    });

    builder.addCase(getPendingKyc.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getPendingKyc.fulfilled, (state, action) => {
      state.loading = false;
      state.pendingKycData = action.payload;
      if (action.payload?.kycDetails) {
        state.kycHistoryData = {
          kycDetails: action.payload.kycDetails,
          directorName: action.payload.directorName,
          orgDets: action.payload,
        };
      }
    });
    builder.addCase(getPendingKyc.rejected, (state, action) => {
      state.loading = false;
      state.pendingKycData = {};
      state.error = action.payload;
    });

    builder.addCase(kycHistory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(kycHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.kycHistoryData = action.payload;
    });
    builder.addCase(kycHistory.rejected, (state, action) => {
      state.loading = false;
      state.kycHistoryData = {};
      state.error = action.payload;
    });

    builder.addCase(getConsentDigilocker.pending, (state) => {
      state.digilockerLoading = true;
      state.error = "";
    });
    builder.addCase(getConsentDigilocker.fulfilled, (state, action) => {
      state.digilockerLoading = false;
      state.captche = action.payload.response;
    });
    builder.addCase(getConsentDigilocker.rejected, (state, action) => {
      state.digilockerLoading = false;
      state.captche = [];
      state.error = action.payload;
    });

    builder.addCase(getAadhaarAndPan.pending, (state) => {
      state.AadharPanLoading = true;
      state.AadharPanError = "";
    });
    builder.addCase(getAadhaarAndPan.fulfilled, (state, action) => {
      state.AadharPanLoading = false;
      state.AadharPanError = action.payload;
    });
    builder.addCase(getAadhaarAndPan.rejected, (state, action) => {
      state.AadharPanLoading = false;
      state.aadhaarPanData = [];
      state.AadharPanError = action.payload;
    });

    builder.addCase(verifyAadhaarCaptcha.pending, (state) => {
      state.verifyCaptchaloading = true;
      state.error = "";
    });
    builder.addCase(verifyAadhaarCaptcha.fulfilled, (state, action) => {
      state.verifyCaptchaloading = false;
      state.AadharOtpData = action.payload.response;
    });
    builder.addCase(verifyAadhaarCaptcha.rejected, (state, action) => {
      state.verifyCaptchaloading = false;
      state.AadharOtpData = {};
      state.error = action.payload.error;
    });

    builder.addCase(verifyAadhaarOtp.pending, (state) => {
      state.aadharValidateLoading = true;
      state.error = "";
    });
    builder.addCase(verifyAadhaarOtp.fulfilled, (state, action) => {
      state.aadharValidateLoading = false;
      state.error = "";
    });
    builder.addCase(verifyAadhaarOtp.rejected, (state, action) => {
      state.aadharValidateLoading = false;
      state.error = action.payload;
    });

    builder.addCase(pendingKycSubmit.pending, (state) => {
      state.pendingKycSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(pendingKycSubmit.fulfilled, (state, action) => {
      state.pendingKycSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(pendingKycSubmit.rejected, (state, action) => {
      state.pendingKycSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(financialDocUpload.pending, (state) => {
      state.pendingKycSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(financialDocUpload.fulfilled, (state, action) => {
      state.pendingKycSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(financialDocUpload.rejected, (state, action) => {
      state.pendingKycSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(verifyDoc.pending, (state) => {
      state.verifyDocLoading = true;
      state.error = "";
    });
    builder.addCase(verifyDoc.fulfilled, (state, action) => {
      state.verifyDocLoading = false;
      state.error = "";
    });
    builder.addCase(verifyDoc.rejected, (state, action) => {
      state.verifyDocLoading = false;
      state.error = action.payload;
    });

    builder.addCase(rejectDoc.pending, (state) => {
      state.rejectDocLoading = true;
      state.rejectDocError = "";
    });
    builder.addCase(rejectDoc.fulfilled, (state, action) => {
      state.rejectDocLoading = false;
      state.rejectDocError = "";
    });
    builder.addCase(rejectDoc.rejected, (state, action) => {
      state.rejectDocLoading = false;
      state.rejectDocError = action.payload;
    });

    builder.addCase(reviewKycSubmit.pending, (state) => {
      state.reviewKycSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(reviewKycSubmit.fulfilled, (state, action) => {
      state.reviewKycSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(reviewKycSubmit.rejected, (state, action) => {
      state.reviewKycSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(blacklistBus.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(blacklistBus.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(blacklistBus.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(deliquentBus.pending, (state) => {
      state.commentSubmitLoading = true;
      state.commentSubmitError = "";
    });
    builder.addCase(deliquentBus.fulfilled, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = "";
    });
    builder.addCase(deliquentBus.rejected, (state, action) => {
      state.commentSubmitLoading = false;
      state.commentSubmitError = action.payload;
    });

    builder.addCase(sendKycRemainder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(sendKycRemainder.fulfilled, (state, action) => {
      state.loading = false;
      state.kycRemainder = action.payload;
    });
    builder.addCase(sendKycRemainder.rejected, (state, action) => {
      state.loading = false;
      state.kycRemainder = "";
      state.error = action.payload;
    });

    ////////////kyc verification///////////////////////////////////////////////////////

    builder.addCase(busGetIndBusAtList.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(busGetIndBusAtList.fulfilled, (state, action) => {
      state.loading = false;
      state.error = "";
      state.dropdownData = action.payload;
    });
    builder.addCase(busGetIndBusAtList.rejected, (state, action) => {
      state.loading = false;
      state.dropdownData = {};
      state.error = action.payload;
    });

    builder.addCase(busVerifyBusPan.pending, (state) => {
      state.panLoading = true;
      state.panError = "";
    });
    builder.addCase(busVerifyBusPan.fulfilled, (state, action) => {
      state.panLoading = false;
      state.panData = action.payload;
    });
    builder.addCase(busVerifyBusPan.rejected, (state, action) => {
      state.panLoading = false;
      state.panData = {};
      state.panError = action.payload;
    });

    builder.addCase(busVerifyDirectorPan.pending, (state) => {
      state.directorPanLoading = true;
      state.error = "";
    });
    builder.addCase(busVerifyDirectorPan.fulfilled, (state, action) => {
      state.directorPanLoading = false;
      state.error = "";
    });
    builder.addCase(busVerifyDirectorPan.rejected, (state, action) => {
      state.directorPanLoading = false;
      state.error = action.payload;
    });

    builder.addCase(busVerifyBusGstin.pending, (state) => {
      state.gstinLoading = true;
      state.error = "";
    });
    builder.addCase(busVerifyBusGstin.fulfilled, (state, action) => {
      state.gstinLoading = false;
      state.error = "";
    });
    builder.addCase(busVerifyBusGstin.rejected, (state, action) => {
      state.gstinLoading = false;
      state.error = action.payload;
    });

    builder.addCase(busVerifyIfsc.pending, (state) => {
      state.ifscLoading = true;
      state.error = "";
    });
    builder.addCase(busVerifyIfsc.fulfilled, (state, action) => {
      state.ifscLoading = false;
      state.ifscData = action.payload.response;
    });
    builder.addCase(busVerifyIfsc.rejected, (state, action) => {
      state.ifscLoading = false;
      state.ifscData = {};
      state.error = action.payload;
    });

    builder.addCase(busVerifyBank.pending, (state) => {
      state.bankLoading = true;
      state.error = "";
    });
    builder.addCase(busVerifyBank.fulfilled, (state, action) => {
      state.bankLoading = false;
      state.error = "";
    });
    builder.addCase(busVerifyBank.rejected, (state, action) => {
      state.bankLoading = false;
      state.error = action.payload;
    });

    builder.addCase(busGetPendingKyc.pending, (state) => {
      state.loading = true;
      state.error = "";
      state.isLinkExpired = false;
    });
    builder.addCase(busGetPendingKyc.fulfilled, (state, action) => {
      state.loading = false;
      state.isLinkExpired = false;
      state.pendingKycData = action.payload;
      if (action.payload?.kycDetails) {
        state.kycHistoryData = {
          kycDetails: action.payload.kycDetails,
          directorName: action.payload.directorName,
          orgDets: action.payload,
        };
      }
    });
    builder.addCase(busGetPendingKyc.rejected, (state, action) => {
      state.loading = false;
      state.pendingKycData = {};
      state.error = action.payload;
      if (
        action.payload?.isLinkExpired ||
        (typeof action.payload === "string" && action.payload.toLowerCase().includes("expired")) ||
        (typeof action.error?.message === "string" && action.error.message.toLowerCase().includes("expired"))
      ) {
        state.isLinkExpired = true;
      }
    });

    builder.addCase(busKycHistory.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(busKycHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.kycHistoryData = action.payload;
    });
    builder.addCase(busKycHistory.rejected, (state, action) => {
      state.loading = false;
      state.kycHistoryData = {};
      state.error = action.payload;
    });

    builder.addCase(busGetAadhaarCaptcha.pending, (state) => {
      state.digilockerLoading = true;
      state.error = "";
    });
    builder.addCase(busGetAadhaarCaptcha.fulfilled, (state, action) => {
      state.digilockerLoading = false;
      state.captche = action.payload.response;
    });
    builder.addCase(busGetAadhaarCaptcha.rejected, (state, action) => {
      state.digilockerLoading = false;
      state.captche = [];
      state.error = action.payload;
    });

    builder.addCase(busVerifyAadhaarCaptcha.pending, (state) => {
      state.verifyCaptchaloading = true;
      state.error = "";
    });
    builder.addCase(busVerifyAadhaarCaptcha.fulfilled, (state, action) => {
      state.verifyCaptchaloading = false;
      state.AadharOtpData = action.payload.response;
    });
    builder.addCase(busVerifyAadhaarCaptcha.rejected, (state, action) => {
      state.verifyCaptchaloading = false;
      state.AadharOtpData = {};
      state.error = action.payload.error;
    });

    builder.addCase(busVerifyAadhaarOtp.pending, (state) => {
      state.aadharValidateLoading = true;
      state.error = "";
    });
    builder.addCase(busVerifyAadhaarOtp.fulfilled, (state, action) => {
      state.aadharValidateLoading = false;
      state.error = "";
    });
    builder.addCase(busVerifyAadhaarOtp.rejected, (state, action) => {
      state.aadharValidateLoading = false;
      state.error = action.payload;
    });

    builder.addCase(busKycSubmit.pending, (state) => {
      state.pendingKycSubmitLoading = true;
      state.error = "";
    });
    builder.addCase(busKycSubmit.fulfilled, (state, action) => {
      state.pendingKycSubmitLoading = false;
      state.error = "";
    });
    builder.addCase(busKycSubmit.rejected, (state, action) => {
      state.pendingKycSubmitLoading = false;
      state.error = action.payload;
    });

    builder.addCase(busGetConsentDigilocker.pending, (state) => {
      state.digilockerLoading = true;
      state.error = "";
    });
    builder.addCase(busGetConsentDigilocker.fulfilled, (state, action) => {
      state.digilockerLoading = false;
      state.captche = action.payload.response;
    });
    builder.addCase(busGetConsentDigilocker.rejected, (state, action) => {
      state.digilockerLoading = false;
      state.captche = [];
      state.error = action.payload;
    });

    builder.addCase(busGetAadhaarAndPan.pending, (state) => {
      state.AadharPanLoading = true;
      state.AadharPanError = "";
    });
    builder.addCase(busGetAadhaarAndPan.fulfilled, (state, action) => {
      state.AadharPanLoading = false;
      state.AadharPanError = action.payload;
    });
    builder.addCase(busGetAadhaarAndPan.rejected, (state, action) => {
      state.AadharPanLoading = false;
      state.aadhaarPanData = [];
      state.AadharPanError = action.payload;
    });

    builder.addCase(getRmCities.fulfilled, (state, action) => {
      state.allCities = action.payload;
    });
  },

  reducers: {
    updateErrorStatus(state) {
      state.error = "";
      state.commentSubmitError = "";
      state.panError = "";
      state.gstinError = "";
      state.AadharPanError = "";
      state.isLinkExpired = false;
    },
    updateKycData(state) {
      state.pendingKycData = {};
    },
    setLinkExpired(state, action) {
      state.isLinkExpired = action.payload;
    },
  },
});

export const { updateErrorStatus, updateKycData, setLinkExpired } = EnqMngtSlice.actions;

export default EnqMngtSlice.reducer;
